import React from 'react';
import { ToroLearnIcon } from 'presentation/components/icon';

import './styles.scss';

interface IProps {
    title: string;
    subtitle: string;
    link: string;
    onClick: () => void;
}

export const ToroCTACard = ({ title, subtitle, link, onClick }: IProps): JSX.Element => (
    <div className="cta-card row align-items-center py-4">
        <div className="col-12 col-sm-2 text-center">
            <ToroLearnIcon icon="lamp" fill="#E7517E" size={50} className="mx-auto" />
        </div>
        <div className="col-10 col-sm-6 p-0">
            <h4>{title}</h4>
            <p className="text-gray-dark mb-0">{subtitle}</p>
        </div>
        <div className="col-12 col-sm-4 text-center">
            <a onClick={onClick} href={link} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                Acessar
            </a>
        </div>
    </div>
);
